import { create } from 'zustand';

interface UserInfoProps {
  access_token: string;
  email: string;
  phone: string;
  full_name: string;
  id: string;
}

interface UserInfoStateProps {
  userInfo?: UserInfoProps;
  setUserInfo: (userInfo: UserInfoProps) => void;
}

export const useUserInfoState = create<UserInfoStateProps>(set => ({
  userInfo: undefined,
  setUserInfo: userInfo => set(state => ({ ...state, userInfo })),
}));
